import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideFilter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22 3H2l8 9.46V19l4 2v-8.54z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideFilter);
const Memo = memo(ForwardRef);
export default Memo;
